import { Configuration } from '@azure/msal-browser';

export const msalConfigB2C: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AUTH_CLIENT_ID,
    authority: import.meta.env.VITE_AUTH_AUTHORITY,
    knownAuthorities: [import.meta.env.VITE_AUTH_KNOWN_AUTHORITIES],
    redirectUri: `${globalThis.location.origin}/app-initializer`,
    postLogoutRedirectUri: `${globalThis.location.origin}`,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

export const msalConfigB2E: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AUTH_INTERNAL_CLIENT_ID,
    authority: import.meta.env.VITE_AUTH_INTERNAL_AUTHORITY,
    knownAuthorities: [import.meta.env.VITE_AUTH_KNOWN_AUTHORITIES],
    redirectUri: `${globalThis.location.origin}/app-initializer`,
    postLogoutRedirectUri: `${globalThis.location.origin}`,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile'],
  extraQueryParameters: { scheme: 'caeconnect' },

  get loginHint() {
    return sessionStorage.getItem('loginHint') || '';
  },
};
